import { Icon } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import Helpers from "utils/Helpers";
import InvoiceHelpers from "utils/InvoiceHelpers";

function InvoiceExportButton({ companyId, fromDate, toDate }) {
  const handleExport = async () => {
    if (!companyId || !fromDate || !toDate) return;
    const response = await InvoiceHelpers.search(companyId, fromDate, toDate);

    if (!response || !response.data.data || response.data.data.length === 0) {
      return;
    }

    const fileName = `invoices_${companyId}_${+Date.now()}`;
    Helpers.downloadExcelFile(response.data.data, fileName);
  };

  return (
    <SoftBox mr={3}>
      <SoftButton variant="outlined" color="info" onClick={handleExport}>
        ΕΞΑΓΩΓΗ&nbsp;&nbsp;
        <Icon>folder</Icon>
      </SoftButton>
    </SoftBox>
  );
}

export default InvoiceExportButton;
